export default __webpack_public_path__ + "static/media/about1-s2-i2.4046c333.png";